import React, { useEffect, useState } from 'react'
import RemoteSvgWithJS from './RemoteSvgWithJS.jsx'
import RemoteSvgWithCSS from './RemoteSvgWithCSS.jsx'
import { safeFetch } from '../../../global/data/service.js'

const RemoteSvg = ({
  url = '',
  fallbackImageUrl = '',
  fallbackImageClasses = '',
  alignment = 'center',
  classNames = '',
  title = '',
  ...props
}) => {
  const [svgContent, setSvgContent] = useState(null)
  const randomIdRef = React.useRef('id-' + Math.random().toString(36).slice(2))
  const alignmentClass = `u-flex u-flexCol ${alignment === 'left' ? 'u-flexAlignItemsStart' : alignment === 'right' ? 'u-flexAlignItemsEnd' : 'u-flexAlignItemsCenter'}`

  useEffect(() => {
    if (!url) return
    safeFetch(url)
      .then((res) => res.text())
      .then(setSvgContent)
  }, [url])

  return (
    <>
      {svgContent && svgContent.indexOf('<svg') !== -1 ? (
        <>
          <div className="u-printHidden u-overflowHidden">
            {svgContent.indexOf('<script>') !== -1 ? (
              <RemoteSvgWithJS
                id={randomIdRef.current}
                url={url}
                svgContent={svgContent}
                title={title}
                classNames={`${classNames} ${alignmentClass}`}
                {...props}
              />
            ) : (
              <RemoteSvgWithCSS
                url={url}
                svgContent={svgContent}
                classNames={`${classNames} ${alignmentClass}`}
                {...props}
              />
            )}
          </div>
          {fallbackImageUrl ? (
            <img
              src={fallbackImageUrl}
              alt="Fallback"
              className={`u-hidden u-printVisible ${fallbackImageClasses}`}
            />
          ) : null}
        </>
      ) : fallbackImageUrl ? (
        <img
          src={fallbackImageUrl}
          alt="Fallback"
          className={`${fallbackImageClasses}`}
        />
      ) : null}
    </>
  )
}

export default RemoteSvg
